import '../common/app';

export default angular.module('edge.gateway.quoteandbind.pa.app', ['edge.gateway.quoteandbind.common.app']).value('pa.qnb.editableDriverDOB', true);